<template>
<div style="height:100%">
  <div class="work" style="height:470px;overflow-y: scroll;">
    <div class="eachBox" v-for="item1 in questionTypes">
        <div class="contentBox" v-for="item2 in item1.questions">
            <div class="title"><span><i>{{item2.i}}</i>/{{orginQuestion.total_item_count}}</span>{{item1.type_name}}</div>
            <div class="content" v-html="item2.stem"></div>
            <div class="total">【本题<span>{{item2.questionScore}}</span>分】</div>
            <div class="answer"><span>正确答案：</span><i v-html="item2.answer||'无'"></i></div>
            <div class="answer"><span>答案解析：</span><i v-html="item2.analysis"></i></div>
            <div class="answer_user"><span>您的答案：</span>{{item2.userAnswer}}</div>
            <div class="ziping">
                <span>估算本题得分：</span>
                <input type="number" v-model="item2.pingfen">
                <i class="errorTip" v-if="item2.showTip||item2.pingfen>item2.questionScore||item2.pingfen<0">*请填写正确得分</i>
            </div>
        </div>
    </div>
  </div>
  <div class="btnBox">
        <button class="close" @click="goReport">关闭</button>
        <button class="submit" @click="submit">提交</button>
    </div>
</div>
</template>
<script>
import {
  SaveScores
} from "@/api/index";
export default {
    props:{
        zgData:''
    },
  data() {
    return {
      MAIN_CLASS: this.GLOBAL.MAIN_CLASS, //类名
      URL_MAQIN: this.GLOBAL.PLATFORM,
      questionTypes:[],
      orginQuestion:''
    };
  },
  methods:{
    getQuestionTypes(){
        console.log(this.zgData)
        if(!this.zgData) return []
        this.orginQuestion = this.zgData
        for(let key in this.zgData.questionTypes){
            if(key>4){
                for(let item of this.zgData.questionTypes[key].questions){
                this.$set(item,'pingfen','')
                this.$set(item,'showTip',false)//用作必填时的判断显示//暂时废弃
                }
                this.questionTypes.push(this.zgData.questionTypes[key])
            }
        }
        // console.log(this.questionTypes)
    },
    submit(){
        //数据整理
        let obj = {
            "result_id":this.zgData.id,
            "scores":{}
        }

        //过滤
        for(let item1 of this.questionTypes){
            for(let item2 of item1.questions){
                if(item2.pingfen>item2.questionScore||item2.pingfen<0)
                return this.$alert('请检查错误的评分', '蜜蜂岛提醒您', {
                    confirmButtonText: '知道啦',
                    callback: action => {
                        
                    }
                });
                else{
                    if(item2.pingfen)
                        obj.scores[`"${item2.question_id}"`] = item2.pingfen
                }
            }
        }
        console.log('评分',obj)
        //提交
        SaveScores(obj).then(res=>{
            this.goReport()
        })
    },
    goReport(){
        this.$layer.closeAll('iframe');
        this.$router.push({
            path: "report",
            query: { id: this.zgData.id, exam: "exam" }
        })
    },


  },
  created() {
      this.getQuestionTypes()
  }

};
</script>
<style lang="scss" scoped>
i{
    font-style: normal;
}
.eachBox{
    border-bottom: 15px solid rgba(249,249,249,1);
    &:last-of-type{
        border: 0;
    }
}
.contentBox{
    background: white;
    padding: 0 66px 0 24px;
    padding-bottom: 32px;
    border-bottom: 15px solid rgba(249,249,249,1);
    overflow: hidden;
    &:last-of-type{
        border: 0;
    }
    .title{
        margin-top: 19px;
        font-size:16px;
        font-weight:400;
        color:rgba(51,51,51,1);
        span{
            font-size:16px;
            font-weight:400;
            color:#333333;
            margin-right: 4px;
            i{
                font-size:16px;
                font-weight:400;
                color:rgba(255,0,54,1);
            }
        }
    }
    .content{
        margin-top: 7px;
        font-size:16px;
        font-weight:600;
        color:rgba(0,0,0,1);
        line-height:22px;
    }
    .total{
        font-size:14px;
        font-weight:500;
        color:rgba(51,51,51,1);
        margin-top: 16px;
        span{
            font-size:14px;
            font-weight:500;
            color: rgb(206,122,34);
            padding: 0 4px;
        }
    }
    .answer{
        font-size:14px;
        font-weight:500;
        color:rgba(51,51,51,1);
        margin-top: 16px;
        >span{
            display: block;
        }
        span{
            font-weight:600;
        }
        i,p,span{
            display: inline-block;
        }
    }
    .answer_user{
        font-size:14px;
        font-weight:500;
        color:rgba(51,51,51,1);
        margin-top: 16px;
        span{
            font-weight:600;
            color:rgba(0,145,255,1);
        }
    }
    .ziping{
        margin-top: 16px;
        span{
            font-weight:600;
            color:rgba(0,145,255,1);
        }
        input{
            width: 211px;
            height:23px;
            background:rgba(255,255,255,1);
            border:2px solid rgba(204,204,204,1);
        }
        .errorTip{
            padding-left: 20px;
            font-size:14px;
            font-weight:600;
            color:rgba(254,76,75,1);
        }
    }
    
}
.btnBox{
    border-top: 1px solid #EEEEEE;
    text-align: center;
    padding-top: 15px;
    button{
        width:160px;
        height:32px;
        font-size:14px;
        font-weight:400;
        border: 0;
        border-radius: 4px;
        cursor: pointer;
    }
    .close{
        background:rgba(238,238,238,1);
        color:rgba(51,51,51,1);
        margin-right: 31px;
    }
    .submit{
        background:rgba(0,145,255,1);
        color:rgba(255,255,255,1);
    }
}
</style>
